/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Type_In_Use_OneInputs */

const en_sch_err_type_in_use_one = /** @type {(inputs: Sch_Err_Type_In_Use_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item still uses this type. Move it to another type first.`)
};

const de_sch_err_type_in_use_one = /** @type {(inputs: Sch_Err_Type_In_Use_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch 1 Vorgang nutzt diesen Typ. Verschiebe ihn zuerst in einen anderen Typ.`)
};

/**
* | output |
* | --- |
* | "1 item still uses this type. Move it to another type first." |
*
* @param {Sch_Err_Type_In_Use_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_type_in_use_one = /** @type {((inputs?: Sch_Err_Type_In_Use_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Type_In_Use_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_type_in_use_one(inputs)
	return en_sch_err_type_in_use_one(inputs)
});